import { createContext, Dispatch, SetStateAction } from 'react';

type SnackBarContextType = {
  setShowSnackbar: Dispatch<SetStateAction<boolean>>;
  setSnackbarDetails: Dispatch<SetStateAction<{ type: string; details: string }>>;
};

export const SnackBarContext = createContext<SnackBarContextType>({} as SnackBarContextType);
